<template>
  <div class="page noselect pageAsOverlay">
    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->
    <!--        </div> -->

    <!--        <h1 class="myTitle">Datenschutz</h1>-->

    <v-container grid-list-md>
      <div class="text-left mt-7">
        <h2>Datenschutzerklärung</h2>
        <div class="spacer-15"></div>
        <CmsBlock blockName="Datenschutz"></CmsBlock>
        <div>
          <!--                    <a href="http://demo1.appcoast.eu/impressum/"-->
          <!--                       target="_blank">http://demo1.appcoast.eu/impressum/</a>-->
        </div>
      </div>
      <!--            <iframe id="datenschutzIframe" style="height: 487px; width: 100%; background-color: transparent;" scrolling="no"-->
      <!--                    :src="url"-->
      <!--                    sandbox="allow-forms allow-same-origin allow-scripts allow-modals allow-popups"-->
      <!--                    frameborder="0"></iframe>-->
    </v-container>
  </div>
</template>

<script>
// import * as iframe from "../iframe/handleFrameUpdates"
// import {logPageView} from "../firebase/firebaseUtil";
import {jumpToTop} from "@/vendor/util";
import CmsBlock from "@/components/CmsBlock.vue";

export default {
  name: "Datenschutz",
  components: {CmsBlock},

  computed: {
    url() {
      // return 'https://static.qsignal.eu/sudhauswarstein/legal/datenschutz.html'
      return 'https://' + window.location.host + '/legal/datenschutz.html'
    }
  },


  mounted() {
    jumpToTop(true);
    // let _this = this;
    // this.processSizeUpdate = function (e) {
    //   try {
    //     console.log('got some message: ' + JSON.stringify(e));
    //     var myIframe = document.getElementById('datenschutzIframe');
    //     if (myIframe.src && myIframe.src.indexOf(e.origin) === 0) {
    //       try {
    //         var data = JSON.parse(e.data);
    //         console.log('raw data = ' + e.data);
    //
    //         if (data.event === 'iframeHeight') {
    //           _this.iframeLoaded = true;
    //           myIframe.style.height = (data.height + 40) + 'px';
    //           console.log('iframe height has been updated');
    //         } else if (data.event === 'gotoSortiment') {
    //           _this.$router.push({name: 'Sortiment'});
    //         }
    //       } catch (e) {
    //         alert('Parsing error: ' + e);
    //         console.log('error: ', e);
    //       }
    //     }
    //   } catch (e) {
    //     // alert('Uups parsing rawData error: ' + e);
    //     console.log('Uups parsing rawData error: ' + e);
    //   }
    // };
    // window.addEventListener("message", this.processSizeUpdate, false);
  },

  destroyed() {
    // try {
    //   window.removeEventListener("message", this.processSizeUpdate);
    // } catch (e) {
    //   console.log('Error removing processSizeUpdate: ' + e.message);
    // }
  },

}
</script>

<style scoped lang="scss">

</style>
